import { Button, Box, CircularProgress } from "@mui/material";

interface CreateAccountStepProps {
  loading: boolean;
  onCreateAccount: () => Promise<void>;
}

const CreateAccountStep = ({ loading, onCreateAccount }: CreateAccountStepProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {loading ? (
        <CircularProgress />
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={onCreateAccount}
          disabled={loading}
          size="large">
          Set Up Stripe Integration
        </Button>
      )}
    </Box>
  );
};

export default CreateAccountStep; 